import React, { forwardRef } from 'react'

import PropTypes from 'prop-types'

import join from 'lodash/join'
import map from 'lodash/map'
import uniqueId from 'lodash/uniqueId'
import upperFirst from 'lodash/upperFirst'

import {
  Divider,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core'

import Button from '@galo-monitor/web-components/Button'
import Popover from '@galo-monitor/web-components/Popover'

const PopoverAddButton = forwardRef( ({ classes, list, disabled, onClick, t }, multipleActionsPopoverRef) => (
  <Popover
    ref={ multipleActionsPopoverRef }
    popoverId={ uniqueId('popover-actions') }
    Component={ props => (
      <Button
        id="custom-add-button-activities"
        color="primary"
        onClick={ onClick }
        disabled={ disabled }
        { ...props }
      >
        {t('register')}
      </Button>
    ) }
  >
    <List style={ { padding: 0 } }>
      {map(list, activityType => (
        <React.Fragment key={ uniqueId(activityType) }>
          <ListItem
            className={ join([classes.item, classes.actionItem], ' ') }
            onClick={ () => onClick(activityType) }
            button
          >
            <ListItemText primary={ upperFirst(t(`${ activityType } activity type`)) } />
          </ListItem>
          <Divider style={ { margin: 0 } } />
        </React.Fragment>
      ))}
    </List>
  </Popover>
))

PopoverAddButton.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default PopoverAddButton
